import { Navigation } from "Core";
import { ITextBlockArray } from "Entities";
import { ServiceProvider } from "Service";
import { Language } from "Service/Client/ServiceClient";
import { Configuration } from "Configuration";
import { AppContext } from "./AppContext";

/**
 * @hidden
 */
export class Login {
    public static viewModel: kendo.data.ObservableObject;

    private static showLanguageSelector: boolean;

    private static textBlockCategory = "login";

    private static container: JQuery;

    private static service: ServiceProvider;

    private static appContext: AppContext;

    private static languageDropDown: kendo.ui.DropDownList;

    private static setLanguage(language: string, textblocks: ITextBlockArray, languages: Language[]): void {
        for (let i = 0, len = languages.length; i < len; i++) {
            let tbName = "language" + languages[i].LanguageCode;
            languages[i].LanguageDescription =
                this.service.TextBlock.getChecked(textblocks, tbName, this.textBlockCategory) || languages[i].LanguageDescription;
        }
        if (this.showLanguageSelector) {
            this.viewModel.set("Languages", languages);
            if (this.languageDropDown) {
                this.languageDropDown.refresh();
            }
        }
        this.viewModel.set("TextBlock", textblocks);
        document.title = textblocks["pageTitle"];
    }

    public static initialize(
        container: JQuery,
        showLanguageSelector: boolean,
        defaultLanguage: string,
        uniqueApplicationName: string,
        baseUrl: string
    ): Promise<void> {
        this.container = container;
        this.showLanguageSelector = showLanguageSelector;

        this.appContext = AppContext.current ?? new AppContext();
        this.appContext.configure({
            UniqueApplicationName: uniqueApplicationName,
        });
        Configuration.baseUrl = baseUrl;
        this.service = this.appContext.serviceProvider;

        this.viewModel = kendo.observable({
            TextBlock: null,
            isLoaded: false,
            Languages: [],
            SelectedLanguage: null,
        });
        const usedTextBlocks = [
            "pageTitle",
            "pageDescription",
            "username",
            "password",
            "login",
            "locallogin",
            "rememberlogin",
            "SendPassword",
            "externallogin",
            "WinLogin",
            "emptyLoginFields",
            "loginNotValid",
        ];

        for (const textblock of usedTextBlocks) {
            (<any>this.viewModel)[`getTextBlock${textblock}`] = function () {
                const textBlocks = this.get("TextBlock");
                return AppContext.current.serviceProvider.TextBlock.getChecked(textBlocks, textblock, this.textBlockCategory);
            };
        }

        this.viewModel.bind("change", (e: any) => {
            if (e.field == "SelectedLanguage") {
                let languageCode = this.viewModel.get("SelectedLanguage").LanguageCode;
                this.service.TextBlock.load(languageCode, this.textBlockCategory, false).then((textblocks) => {
                    this.setLanguage(languageCode, textblocks[this.textBlockCategory], this.viewModel.get("Languages"));
                    this.viewModel.set("isLoaded", true);
                    this.container.parent().removeClass("dms-hidden").addClass("animated fadeIn");
                });
            }
        });
        let loadPromise = this.service.TextBlock.load(defaultLanguage, this.textBlockCategory).then((textblocks) => {
            if (this.showLanguageSelector) {
                this.service.Language.get().then((languages) => {
                    this.setLanguage(defaultLanguage, textblocks[this.textBlockCategory], languages);
                    let selectedLanguage: Language;
                    for (let i = 0, len = languages.length; i < len; i++) {
                        if (languages[i].LanguageCode == defaultLanguage) {
                            selectedLanguage = languages[i];
                        }
                    }
                    this.viewModel.set("SelectedLanguage", selectedLanguage || languages[0]);
                });
            } else {
                this.setLanguage(defaultLanguage, textblocks[this.textBlockCategory], []);
                this.viewModel.set("isLoaded", true);
                this.container.parent().removeClass("dms-hidden").addClass("animated fadeIn");
            }
        });

        kendo.bind(this.container, this.viewModel);
        const inputUsername = this.container.find("#Username");
        const inputPassword = this.container.find("#Password");
        this.languageDropDown = this.container.find("#input-language").data("kendoDropDownList");

        this.container.find("#dms-button-login").on("click", () => {
            if (!inputUsername.val() || !inputPassword.val()) {
                Navigation.errorAsync((<any>this.viewModel).getTextBlockemptyLoginFields(), "Error");
            } else {
                kendo.ui.progress(this.container, true);
                this.container.find("#dms-form-login").trigger("submit");
            }
            return false;
        });

        // $("#btnSendPassword").on("click", () => {
        //     const userName = $("#input-username").val();
        //     if (!userName) {
        //         Navigation.errorAsync((<any>this.viewModel).getTextBlock("usernameMissing"), "Error");
        //     } else {
        //         kendo.ui.progress($("body"), true);
        //         $("#input-username-sendpassword").val(userName);
        //         $("#form-sendpassword").trigger("submit");
        //     }
        //     return false;
        // });
        return loadPromise;
    }
}
